import styled from 'styled-components';

import { SuccessPageStyles as BaseSuccessPageStyles } from '../MultigenderWeb/MultigenderWeb.styles';

export const SuccessPageStyles = BaseSuccessPageStyles;

/** Та же кнопка "Web version", что в MultigenderWeb; при одной кнопке — на всю ширину как в Trans */
export const WebVersionLink = styled.div`
  width: 100%;
  max-width: 380px;
  margin: 0 auto 14px;
  border-radius: 6px;
  border: 1px solid #a6a6a6;
  background: #000;
  color: #fff;
  padding: 8px 16px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: inherit;
    font-weight: bold;
    text-decoration: none;

    ion-icon {
      font-size: 24px;
    }
  }
`;
